// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2CrcH","author":"Table_author__14EAJ","authorImage":"Table_authorImage__3Wh3e","unreadRow":"Table_unreadRow__3N928"};